import React, { useEffect, useState } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  Creature,
} from "@dndModels";
import { SIZE_MAP } from "@dndModels/Constants";

// import API from "../../utilities/system_api";
import { makeStyles } from "@utilities/theme_utilities";

import AddButton from "@components/input/buttons/icon_buttons/AddButton";
import RemoveButton from "@components/input/buttons/RemoveButton";
import DisplayStringWithReplacements from "@dndComponents/display/DisplayStringWithReplacements";

interface Props { 
  creature: Creature;
  count: number;
  disabled: boolean;
  onChange: (count: number) => void;
}

// const api = API.getInstance();

export default function CreatureParticipant({ 
  creature,
  count,
  disabled,
  onChange
}: Props) {
  const [in_encounter, setInEncounter] = useState(count);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (count !== in_encounter) {
      setInEncounter(count);
    }
    // eslint-disable-next-line
  }, [count]);
    
  const useStyles = makeStyles()((theme) => {
    return ({
      root: {
        // margin: "4px",
        backgroundColor: theme.palette.secondary.main
      },
    });
  });

  const { classes, cx } = useStyles();

  return (
    <div className='padded'>
      <Grid container spacing={0} direction="row" className={cx(classes.root)} style={{ width: "100%" }}>
        <Grid
          size={{
            xs: 3
          }}>
          <AddButton
            disabled={disabled}
            onClick={ () => {
              const newCount = in_encounter + 1;
              setInEncounter(newCount);
              // if (full_creature) {
                onChange(newCount);
              // } else {
              //   api.getFullObject("creature", creature._id).then(res => {
              //     if (res instanceof Creature) {
              //       setFullCreature(res);
              //       onChange(res, newCount);
              //     }
              //   });
              // }
            }}
          />
          &nbsp;{ in_encounter }&nbsp;
          <RemoveButton
            disabled={ disabled || in_encounter === 0 }
            onClick={ () => {
              const newCount = in_encounter - 1;
              setInEncounter(newCount);
              onChange(newCount);
            }}
          />
        </Grid>
        <Grid
          container
          spacing={0}
          direction="row"
          className="clickable"
          onClick={() => {
              setExpanded(!expanded);
            }}
          size={{
            xs: 9
          }}>
          <Grid
            size={{
              xs: 12
            }}>
            { creature.true_name }
          </Grid>
          <Grid
            className='small_label gray'
            size={{
              xs: 12
            }}>
            { SIZE_MAP[creature.size_num] } CR { creature.challenge_rating } { creature.creature_type }
          </Grid>
        </Grid>
        { expanded &&
          <Grid
            style={{ backgroundColor: "black", border: "1px solid" }}
            size={{
              xs: 12
            }}>
            <DisplayStringWithReplacements display_string={creature.description} />
          </Grid>
        }
      </Grid>
    </div>
  );
}
